export default __webpack_public_path__ + "static/media/GM_Cup_Rainbow.180556a3.png";